
import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { HelpCircle } from "lucide-react";

interface FAQ {
  question: string;
  answer: string;
}

interface CountyFAQSectionProps {
  countyName: string;
  faqs: FAQ[];
}

export function CountyFAQSection({ countyName, faqs }: CountyFAQSectionProps) {
  if (!faqs || faqs.length === 0) return null;
  
  return (
    <div className="my-12 bg-white rounded-lg shadow-sm border border-gray-100 p-6">
      <h2 className="text-2xl font-semibold mb-6 text-grandpal-green-dark">
        Frequently Asked Questions About Nursing Homes in {countyName}
      </h2>
      
      <Accordion type="single" collapsible className="w-full">
        {faqs.map((faq, index) => (
          <AccordionItem key={index} value={`faq-${index}`}>
            <AccordionTrigger className="text-left font-medium">
              <div className="flex items-start">
                <HelpCircle className="h-5 w-5 text-grandpal-green mr-2 flex-shrink-0 mt-0.5" />
                <span>{faq.question}</span>
              </div>
            </AccordionTrigger>
            <AccordionContent className="text-grandpal-gray ml-7">
              <p className="leading-relaxed">{faq.answer}</p>
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
}
